import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["text", "formId", "url", "onClick", "noContainer", "onReady", "onSubmit", "onQuestionChanged", "inlineOnMobile", "widgetProps", "standAlone", "aspectRatio"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Button from "../../button";
import GridContainer from "../../grid-container";
import { Container as ModuleContainer, CTAContainer, TypeformContainer, TypeformElement } from "./typeform.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Typeform = function Typeform(_ref) {
  var text = _ref.text,
    formId = _ref.formId,
    url = _ref.url,
    onClick = _ref.onClick,
    noContainer = _ref.noContainer,
    onReady = _ref.onReady,
    onSubmit = _ref.onSubmit,
    onQuestionChanged = _ref.onQuestionChanged,
    inlineOnMobile = _ref.inlineOnMobile,
    widgetProps = _ref.widgetProps,
    standAlone = _ref.standAlone,
    aspectRatio = _ref.aspectRatio,
    rest = _objectWithoutProperties(_ref, _excluded);
  var typeformElement = /*#__PURE__*/_jsx(TypeformElement, _objectSpread(_objectSpread({
    id: formId,
    onReady: onReady,
    onSubmit: onSubmit,
    onQuestionChanged: onQuestionChanged,
    inlineOnMobile: inlineOnMobile,
    aspectRatio: aspectRatio
  }, widgetProps), standAlone && rest));
  if (standAlone) {
    return typeformElement;
  }
  var Container = noContainer ? GridContainer : ModuleContainer;
  return /*#__PURE__*/_jsxs(Container, _objectSpread(_objectSpread({}, rest), {}, {
    children: [/*#__PURE__*/_jsx(TypeformContainer, {
      children: typeformElement
    }), text && url && /*#__PURE__*/_jsx(CTAContainer, {
      children: /*#__PURE__*/_jsx(Button, {
        fullWidth: true,
        "data-gtm-event": "cta_button",
        href: url,
        onClick: onClick,
        children: text
      })
    })]
  }));
};
Typeform.propTypes = {
  formId: PropTypes.string.isRequired,
  noContainer: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string,
  url: PropTypes.string,
  onReady: PropTypes.func,
  onSubmit: PropTypes.func,
  onQuestionChanged: PropTypes.func,
  inlineOnMobile: PropTypes.bool,
  widgetProps: PropTypes.object,
  standAlone: PropTypes.bool,
  aspectRatio: PropTypes.string
};
Typeform.defaultProps = {
  noContainer: false,
  onClick: undefined,
  text: null,
  url: null,
  onReady: undefined,
  onSubmit: undefined,
  onQuestionChanged: undefined,
  inlineOnMobile: undefined,
  widgetProps: null,
  standAlone: false,
  aspectRatio: ''
};
Typeform.displayName = 'Typeform';
export default /*#__PURE__*/memo(Typeform);